import { useEffect, useState } from "react";
import api from "services/api";
import config from "config";
import { getcodCidade } from "functions/gettabconfig";
import DIALOGSORTEADODETALHE from "dialog/dialogsorteadodetalhe";
import Contemplados from "components/contemplados";
import './style.css';

function LISTASORTEADOS() {
    const [pppDSorteado, setpppDSorteado] = useState(false);
    const [dados, setDados] = useState({});
    const [lsorteados, setLSorteados] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para o termo de busca
    const [filteredSorteados, setFilteredSorteados] = useState([]); // Estado para a lista filtrada

    const mostraDetalhe = (d) => {
        setDados(d);
        setpppDSorteado(true);
    };

    useEffect(() => {
        // Busca Participantes
        api.get(`${config.CONTEMPLADOS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                setLSorteados(response.data);
                setFilteredSorteados(response.data); // Inicializa a lista filtrada
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        // Filtra os participantes com base no termo de busca
        setFilteredSorteados(
            lsorteados.filter(lista =>
                lista.nome_sorteado.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, lsorteados]);

    return (
        <div>
            <h1 className="section-title">
                <i className="fas fa-gift" style={{marginRight: '12px'}}></i>
                Ganhadores
            </h1>

            <div className="sorteados-search-container mb-4">
                <div className="input-group search-box">
                    <span className="input-group-text bg-white border-end-0">
                        <i className="fas fa-search text-muted"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control border-start-0 ps-0"
                        placeholder="Buscar por nome do ganhador..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="row">
                {filteredSorteados.map((d) => {
                    return (
                        <div
                            key={`part${d.id_sorteado}`}
                            className="col-12 col-sm-6 col-md-4 col-lg-3 p-2"
                            onClick={() => mostraDetalhe(d)}
                        >
                            <Contemplados
                                banner={d.banner}
                                nome={d.nome}
                                nome_sorteado={d.nome_sorteado}
                                nome_estabelecimento={d.nom_estabelecimento}
                                datasorteio={d.data_sorteio}
                                limages={d.images}
                                />
                        </div>
                    );
                })}
            </div>

            <DIALOGSORTEADODETALHE
                trigger={pppDSorteado}
                setTrigger={setpppDSorteado}
                contemplado={dados}
            />
        </div>
    );
}

export default LISTASORTEADOS;